import * as ActionTypes from './types.action';

export const updateSideBasketStatus = isLoading => ({
  type: ActionTypes.UPDATING_SIDE_BASKET_SUCCESS,
  isLoading
});



// WEBPACK FOOTER //
// ./actions/loading.action.js